module.exports = __webpack_public_path__ + "static/media/nuxt.7c1bf3aa.svg";